import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.login-check';
import * as api from '../../../clients/api';

@Injectable()
export class ApiLoginCheckEffects {

    LoginCheck$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_LOGIN_CHECK),
        mergeMap((x: ac.GetLoginCheckAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getLoginCheck(x.email).pipe(
                map((result: any) => {
                    return new ac.GetLoginCheckErfolgreichAction(result, x.email, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetLoginCheckFehlerAction(error, x.email, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.AccountService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.AccountService {
        if (this.service === null) {
            this.service = this.injector.get(api.AccountService);
        }
        return this.service;
    }
}
